import { Routes } from '@angular/router';
import { ForgotPswdComponent } from './auth/forgot-password/forgot-password.component';
import { RoleGuard } from './auth/guards/role.guard';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { VerificationComponent } from './auth/verification/verification.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { UserRole } from './shared/models/user-role.enum';
import { SuperAdminModule } from './features/dashboard/super-admin/super-admin.module';
import { UserModule } from './features/dashboard/user/dashboard.module';
import { TeacherModule } from './features/dashboard/teacher/teacher.module';
import { TeacherComponent } from './features/dashboard/teacher/teacher.component';
import { UserComponent } from './features/dashboard/user/dashboard-home.component';
import { SuperAdminComponent } from './features/dashboard/super-admin/super-admin.component';
import { PointAndAchievementsComponent } from './features/point-and-achievements/point-and-achievements.component';
import { UserProfileComponent } from './features/user-profile/user-profile.component';
import { SettingsComponent } from './features/settings/settings.component';
import { FAQComponent } from './features/settings/faq/faq.component';
import { FAQCategoriesComponent } from './features/settings/faq-categories/faq-categories.component';
import { UsersComponent } from './features/users/users.component';
import { SchoolsComponent } from './features/schools/schools.component';
import { TeachersComponent } from './features/teachers/teachers.component';
import { StudentsComponent } from './features/students/students.component';
import { StudentEventDetailsComponent } from './features/student-eventDetails/students-eventDetails.component';
import { EventAttendenceStudentsComponent } from './features/student-eventAttendence/students.component';
import { CSQComponent } from './features/csq-team/csq-team.component';
import { EventTypeComponent } from './features/events/event-type/event-type.component';
import { EventListComponent } from './features/events/event-list/event-list.component';
import { EventAttendanceComponent } from './features/events/event-attendance/event-attendance.component';
import { EventManagerComponent } from './features/events/event-managers/event-manager.component';
import { EventMCCPartnersComponent } from './features/events/event-mcc-partners/mcc-partners.component';
import { FocusAreaComponent } from './features/events/focus-area/focus-area.component';
import { AudienceComponent } from './features/events/audience/audience.component';
import { RegionComponent } from './features/events/region/region.component';
import { ReportsComponent } from './features/reports/reports.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { ParentApprovalComponent } from './shared/components/parent-consent-approval/parent-approval.component';
import { ParentStudentMediaConsentComponent } from './shared/components/consent-form-page/consent-form-page.component';
import { ApproveOnboardingComponent } from './shared/components/approve-onboarding/approve-onboarding.component';
import { UnauthorLoginComponent } from './auth/unauthor-login/unauthor-login.component';
import { EventCategoriesComponent } from './features/settings/event-category/event-category.component';
import { EventCategoriesTypeComponent } from './features/settings/event-category-type/event-category-type.component';
import { MediaComponent } from './features/settings/Media/media.component';
import { YearLevelComponent } from './features/settings/year-level/yearlevel.component';
import { EthnicityComponent } from './features/settings/ethnicity/ethnicity.component';
import { EventViewComponent } from './features/events/event-view/event-view.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

  {
    path: 'auth',
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'verification', component: VerificationComponent },
      { path: 'forgot-password', component: ForgotPswdComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
    ],
  },

  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard/user',
        // loadChildren: () =>
        //     import('./features/dashboard/user/dashboard.module').then(
        //     (m) => m.UserModule
        // ),
        component: UserComponent,
        canActivate: [RoleGuard],
        data: { role: UserRole.Student },
      },
      {
        path: 'user/my-profile',
        // loadChildren: () =>
        //     import('./features/user-profile/user-profile.module').then(
        //     (m) => m.UserProfileModule
        // ),
        component: UserProfileComponent,
        canActivate: [RoleGuard],
        data: { role: UserRole.Student },
      },
      {
        path: 'user/point-and-achievements',
        // loadChildren: () =>
        //     import('./features/point-and-achievements/point-and-achievements.module').then(
        //     (m) => m.PointAndAchievementsModule
        // ),
        component: PointAndAchievementsComponent,
        canActivate: [RoleGuard],
        data: { role: UserRole.Student },
      },

      {
        path: 'dashboard/teacher',
        // loadChildren: () =>
        //     import('./features/dashboard/teacher/teacher.module').then(
        //     (m) => m.TeacherModule
        // ),
        component: TeacherComponent,
        canActivate: [RoleGuard],
        data: { role: UserRole.Teacher },
      },
      {
        path: 'dashboard/csq-user',
        // loadChildren: () =>
        //     import('./features/dashboard/csq-admin/csq-admin.module').then(
        //         (m) => m.CsqAdminModule
        //     ),
        // loadChildren: () =>
        //     import('./features/dashboard/super-admin/super-admin.module').then(
        //     (m) => m.SuperAdminModule
        // ),
        component: SuperAdminComponent,
        canActivate: [RoleGuard],
        data: { role: UserRole.CsqUser },
      },
      {
        path: 'dashboard/csq-admin',
        // loadChildren: () =>
        //     import('./features/dashboard/super-admin/super-admin.module').then(
        //     (m) => m.SuperAdminModule
        // ),
        component: SuperAdminComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.CsqAdmin] },
      },
      {
        path: 'dashboard/super-admin',
        // loadChildren: () =>
        //     import('./features/dashboard/super-admin/super-admin.module').then(
        //     (m) => m.SuperAdminModule
        // ),
        component: SuperAdminComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin] },
      },
      {
        path: 'settings',
        // loadChildren: () =>
        //     import('./features/settings/settings.module').then(m => m.SettingsModule),
        component: SettingsComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.Student,
            UserRole.Teacher,
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
          ],
        },
      },
      {
        path: 'faq',
        // loadChildren: () =>
        //     import('./features/settings/faq/faq.module').then(m => m.FAQModule),
        component: FAQComponent,
        canActivate: [RoleGuard],
        // data: { role: [UserRole.Student, UserRole.Teacher, UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser] },
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'faq',
        // loadChildren: () =>
        //     import('./features/settings/faq/faq.module').then(m => m.FAQModule),
        component: FAQComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.Student] },
      },
      {
        path: 'faq/faq-categories',
        // loadChildren: () =>
        //     import('./features/settings/faq-categories/faq-categories.module').then(m => m.FAQCategoriesModule),
        component: FAQCategoriesComponent,
        canActivate: [RoleGuard],
        // data: { role: [UserRole.Student, UserRole.Teacher, UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser] },
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'work-experience-type',
        component: EventCategoriesComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'event-category-type',
        component: EventCategoriesTypeComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'media-library',
        component: MediaComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'year-level',
        component: YearLevelComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'ethnicity',
        component: EthnicityComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin, UserRole.CsqAdmin] },
      },
      {
        path: 'users',
        // loadChildren: () =>
        //     import('./features/users/users.module').then(m => m.UsersModule),
        component: UsersComponent,
        canActivate: [RoleGuard],
        data: {
          role: [UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser],
        },
      },
      {
        path: 'schools',
        // loadChildren: () =>
        //     import('./features/schools/schools.module').then(m => m.SchoolsModule),
        component: SchoolsComponent,
        canActivate: [RoleGuard],
        data: {
          role: [UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser],
        },
      },
      {
        path: 'schools/view/:id',
        // loadChildren: () =>
        //     import('./features/schools/schools.module').then(m => m.SchoolsModule),
        component: SchoolsComponent,
        canActivate: [RoleGuard],
        data: {
          role: [UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser],
        },
      },
      {
        path: 'teachers',
        // loadChildren: () =>
        //     import('./features/teachers/teachers.module').then(m => m.TeachersModule),
        component: TeachersComponent,
        canActivate: [RoleGuard],
        data: {
          role: [UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser],
        },
      },
      {
        path: 'teachers/view/:id',
        // loadChildren: () =>
        //     import('./features/teachers/teachers.module').then(m => m.TeachersModule),
        component: TeachersComponent,
        canActivate: [RoleGuard],
        data: {
          role: [UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser],
        },
      },

      {
        path: 'students',
        // loadChildren: () =>
        //     import('./features/students/students.module').then(m => m.StudentsModule),
        component: StudentsComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
          ],
        },
      },
      {
        path: 'students/view/:id',
        // loadChildren: () =>
        //     import('./features/students/students.module').then(m => m.StudentsModule),
        component: StudentsComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
          ],
        },
      },
      {
        path: 'dashboard/user/event-details/:id',
        // loadChildren: () =>
        //     import('./features/student-eventDetails/students-eventDetails.module').then(m => m.StudentEventDetailsModule),
        component: StudentEventDetailsComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.Student] },
      },
      {
        path: 'eventregistration-attendance',
        // loadChildren: () =>
        //     import('./features/student-eventAttendence/students.module').then(m => m.EventAttendenceStudentsModule),
        component: EventAttendenceStudentsComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.Teacher] },
      },
      {
        path: 'csq-team',
        // loadChildren: () =>
        //     import('./features/csq-team/csq-team.module').then(m => m.CSQTeamModule),
        component: CSQComponent,
        canActivate: [RoleGuard],
        data: { role: [UserRole.SuperAdmin] },
      },
      {
        path: 'events/event-type',
        // loadChildren: () =>
        //     import('./features/events/event-type/event-type.module').then(m => m.EventTypeModule),
        component: EventTypeComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
          ],
        },
      },
      {
        path: 'events/event-list',
        // loadChildren: () =>
        //     import('./features/events/event-list/event-list.module').then(m => m.EventListModule),
        component: EventListComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'events/event-list/view/:id',
        // loadChildren: () =>
        //     import('./features/events/event-list/event-list.module').then(m => m.EventListModule),
        component: EventViewComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
            UserRole.Student
          ],
        },
      },
      {
        path: 'events/event-attendance',
        // loadChildren: () =>
        //     import('./features/events/event-attendance/event-attendance.module').then(m => m.EventAttendanceModule),
        component: EventAttendanceComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'events/event-managers',
        // loadChildren: () =>
        //     import('./features/events/event-managers/event-manager.module').then(m => m.EventManagerModule),
        component: EventManagerComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'events/event-mcc-partners',
        // loadChildren: () =>
        //     import('./features/events/event-mcc-partners/mcc-partners.module').then(m => m.EventMCCpartnersModule),
        component: EventMCCPartnersComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'events/focus-area',
        // loadChildren: () =>
        //     import('./features/events/focus-area/focus-area.module').then(m => m.FocusAreaModule),
        component: FocusAreaComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'events/audience',
        // loadChildren: () =>
        //     import('./features/events/audience/audience.module').then(m => m.AudienceModule),
        component: AudienceComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'events/region',
        // loadChildren: () =>
        //     import('./features/events/region/region.module').then(m => m.RegionModule),
        component: RegionComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.CsqAdmin,
            UserRole.CsqUser,
            UserRole.Teacher,
            UserRole.SuperAdmin,
          ],
        },
      },
      {
        path: 'reports/report-dashboard',
        // loadChildren: () =>
        //     import('./features/reports/reports.module').then(m => m.ReportModule),
        component: ReportsComponent,
        canActivate: [RoleGuard],
        data: {
          role: [UserRole.CsqAdmin, UserRole.SuperAdmin, UserRole.CsqUser],
        },
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        canActivate: [RoleGuard],
        data: {
          role: [
            UserRole.Student,
            UserRole.Teacher,
            UserRole.CsqAdmin,
            UserRole.SuperAdmin,
            UserRole.CsqUser,
          ],
        },
      },
    ],
  },

  {
    path: 'unauthorized',
    // loadComponent: () =>
    //     import('./shared/components/unauthorized/unauthorized.component').then(
    //     (m) => m.UnauthorizedComponent
    // ),
    component: UnauthorizedComponent,
  },

  {
    path: 'parent-approval',
    // loadComponent: () =>
    //     import('./shared/components/parent-consent-approval/parent-approval.component').then(
    //     (m) => m.ParentApprovalComponent
    // ),
    component: ParentApprovalComponent,
  },

  {
    path: 'parent-approval/media-consent',
    // loadComponent: () =>
    //     import('./shared/components/consent-form-page/consent-form-page.component').then(
    //     (m) => m.ParentStudentMediaConsentComponent
    // ),
    component: ParentStudentMediaConsentComponent,
  },

  {
    path: 'auth/unauthorized-login',
    // loadComponent: () =>
    //     import('./shared/components/consent-form-page/consent-form-page.component').then(
    //     (m) => m.ParentStudentMediaConsentComponent
    // ),
    component: UnauthorLoginComponent,
  },

  {
    path: 'event/approve-onboarding',
    // loadComponent: () =>
    //     import('./shared/components/approve-onboarding/approve-onboarding.component').then(
    //     (m) => m.ApproveOnboardingComponent
    // ),
    component: ApproveOnboardingComponent,
  },

  { path: '**', redirectTo: 'auth/login' },
];
